<template>
  <div id="contenedor-observaciones-contrato">
    <template
        v-if="$apollo.queries.auditoriasInformesObservacionesDetalles.loading">
        <v-skeleton-loader
          type="table-heading, table-thead, table-tbody"
        ></v-skeleton-loader>
    </template>
    <template
      v-else>
      <v-simple-table class="pa-3">
        <template v-slot:default>
          <thead>
            <tr>
              <template v-for="header in headers">
                <template>
                  <th
                    :key="header.id">
                    {{ header.text }}
                  </th>
                </template>
              </template>
            </tr>
          </thead>
          <tbody>
            <template v-for="detalle in getListadoContratoObservaciones">
              <template>
                <tr :key="detalle.id" class="body-1">
                  <td>
                    <v-chip
                        dark
                        small
                        outlined
                        :color="getColorFechaVencimiento(detalle.fechaVencimiento)"
                      >
                      <v-icon left small>
                        {{ getIconFechaVencimiento(detalle.fechaVencimiento) }}
                      </v-icon>
                        {{ detalle.fechaVencimiento }}
                      </v-chip>
                  </td>
                  <td>
                    {{ detalle.auditoriaObservacion.auditoriaInforme.auditoria.nombre }}
                  </td>
                  <td>
                    {{ detalle.auditoriaObservacion.auditoriaInforme.nombre }}
                  </td>
                  <td>
                    <v-row no-gutters class="rounded-lg grey lighten-5 pa-1 mb-1 mt-1">
                      <v-col cols="2">
                        <v-badge inline :content="detalle.auditoriaObservacion.numero">
                        </v-badge>
                      </v-col>
                      <v-col cols="10">
                        {{ detalle.auditoriaObservacion.descripcion }}
                        <v-chip x-small
                            :color="getColorStatus(detalle.auditoriaObservacion.estatus)" dark>
                              {{ detalle.auditoriaObservacion.estatus }}
                            <v-icon right x-small
                              v-if="detalle.auditoriaObservacion.estatus === 'SOLVENTADA'">
                              mdi-check
                            </v-icon>
                          </v-chip>
                      </v-col>
                    </v-row>
                  </td>
                  <td>
                    <span>
                      {{ detalle.comentarios }}
                    </span>
                  </td>
                  <td class="text-center">
                    <v-badge
                        :value="detalle.espesificaciones.length > 0"
                        :content="detalle.espesificaciones.length"
                        overlap>
                        <v-btn
                          :disabled="detalle.espesificaciones.length === 0"
                          color="primary"
                          icon
                          @click="handleMostrarEspecificaciones(detalle)">
                          <v-icon>
                            mdi-folder-file
                          </v-icon>
                        </v-btn>
                      </v-badge>
                  </td>
                  <td>
                    <v-tooltip
                      v-if="detalle.auditoriaObservacion.auditoriaInforme.dataFile" top>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          icon
                          v-bind="attrs"
                          v-on="on"
                          color="red"
                          @click="verPdf(detalle.auditoriaObservacion.auditoriaInforme)">
                          <v-icon>mdi-file-pdf-box</v-icon>
                        </v-btn>
                      </template>
                      <span>
                        Ver PDF
                      </span>
                    </v-tooltip>
                    <v-tooltip top>
                      <template v-slot:activator="{ on, attrs }">
                        <template
                          v-if="detalle.seguimientos.length > 0">
                          <v-badge :content="detalle.seguimientos.length" overlap>
                            <v-btn
                              icon
                              v-bind="attrs"
                              v-on="on"
                              @click="mostrarDetalleSeguimiento(detalle)">
                              <v-icon>mdi-folder-file-outline</v-icon>
                            </v-btn>
                          </v-badge>
                        </template>
                        <template
                          v-else>
                          <v-btn
                            icon
                            v-bind="attrs"
                            v-on="on"
                            @click="agregarSeguimientoDetalleObservacion(detalle)">
                            <v-icon>mdi-folder-file-outline</v-icon>
                          </v-btn>
                        </template>
                      </template>
                      <span>Seguimiento ({{ detalle.seguimientos.length }})</span>
                    </v-tooltip>
                  </td>
                </tr>
              </template>
            </template>
          </tbody>
        </template>
      </v-simple-table>
    </template>
    <v-dialog
      v-model="mostrarRegistrarSeguimiento"
      persistent
      scrollable
      width="650px">
      <RegistrarObservacionDetalleSeguimiento
        v-if="esteDetalle"
        :detalle="esteDetalle"
        v-on:cerrar="cancelarRegistrarRespuesta"
        v-on:success="refrescarRegistros">
      </RegistrarObservacionDetalleSeguimiento>
    </v-dialog>
    <v-dialog
      v-model="mostrarSeguimientos"
      persistent
      width="650px">
      <v-card>
        <v-card-title>
          Archivos de Seguimiento
          <v-spacer></v-spacer>
          <v-btn
            icon
            @click="cerrarMostrarSeguimiento">
            <v-icon class="secondary--text" large>highlight_off</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider class="mx-2"></v-divider>
        <v-card-text>
          <div class="d-flex mb-1 mt-1">
            <v-spacer></v-spacer>
          </div>
          <ListadoDetalleSeguimiento
          v-if="esteDetalle"
          :id-detalle="esteDetalle.id">
        </ListadoDetalleSeguimiento>
      </v-card-text>
      <v-card-actions>
          <custom-button
            iconText="mdi-plus"
            tipo="agregar"
            label="Agregar Archivo"
            block
            @click="agregarSeguimientoDetalleObservacion(esteDetalle)">
          </custom-button>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="mostrarArchivosEspecificaciones" persistent width="650px">
      <v-card>
        <v-card-title>
          Especificaciones del Desglose
          <v-spacer></v-spacer>
          <v-btn icon @click="handleCerrarArchivosEspecificaciones">
            <v-icon class="secondary--text" large>highlight_off</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider class="mx-2"></v-divider>
        <v-card-text>
          <ListadoEspesificacions
            v-if="esteDetalle"
            :solo-lectura="true"
            :id-detalle="esteDetalle.id">
          </ListadoEspesificacions>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import AUDITORIAS_INFORMES_OBSERVACIONES_DETALLES from '@/graphql/querys/administracion/auditorias/auditoriasInformesObservacionesDetalles.gql';
import RegistrarObservacionDetalleSeguimiento from '@/components/administracion/auditorias/observaciones/detalles/respuestas/Nueva.vue';
import ListadoDetalleSeguimiento from '@/components/administracion/auditorias/observaciones/detalles/respuestas/Listado.vue';
import CustomButton from '@/components/buttons/Button.vue';
import ListadoEspesificacions from '@/components/administracion/auditorias/observaciones/detalles/respuestas/ListadoEspesificaciones.vue';

export default {
  name: 'MainObservacionesContrato',
  components: {
    RegistrarObservacionDetalleSeguimiento,
    ListadoDetalleSeguimiento,
    CustomButton,
    ListadoEspesificacions,
  },
  data() {
    return {
      conSeguimiento: true,
      esteIdContrato: null,
      mostrarPdfInforme: false,
      mostrarRegistrarSeguimiento: false,
      mostrarSeguimientos: false,
      mostrarArchivosEspecificaciones: false,
      esteDetalle: null,
      esteInforme: null,
      headers: [
        {
          id: 'fecha-vencimiento',
          text: 'F. Vencimiento',
        },
        {
          id: 'auditoria',
          text: 'Auditoría',
        },
        {
          id: 'informe',
          text: 'Informe',
        },
        {
          id: 'observacion',
          text: 'Observación',
        },
        {
          id: 'comentarios',
          text: 'Comentarios',
        },
        {
          id: 'especificaciones',
          text: 'Especificaciones',
        },
        {
          id: 'acciones',
          text: '',
        },
      ],
      page: 1,
      filtros: {
        fechaVencimiento: null,
        idContrato: this.$route.params.idContrato,
        fueEnviada: null,
        estatus: null,
        limit: 20,
        offset: 0,
      },
    };
  },
  apollo: {
    auditoriasInformesObservacionesDetalles: {
      query: AUDITORIAS_INFORMES_OBSERVACIONES_DETALLES,
      variables() {
        return {
          filtros: this.filtros,
        };
      },
    },
  },
  methods: {
    refrescarRegistros() {
      Promise.all([this.refrescarListado()]);
    },
    async refrescarListado() {
      await this.$apollo.queries.auditoriasInformesObservacionesDetalles.refetch({
        filtros: this.filtros,
      });
    },
    verPdf(informe) {
      this.mostrarPdfInforme = !this.mostrarPdfInforme;
      this.esteInforme = informe;
    },
    cancelarVerPdf() {
      this.mostrarPdfInforme = !this.mostrarPdfInforme;
      this.esteInforme = null;
    },
    getDiasRestantes(fechaVencimiento) {
      const formatedFechaVencimiento = new Date(`${fechaVencimiento}`);
      const hoy = new Date();
      const diferenciasEnMilisegundos = formatedFechaVencimiento - hoy;

      return Math.floor(diferenciasEnMilisegundos / (1000 * 60 * 60 * 24));
    },
    getColorFechaVencimiento(fechaVencimiento) {
      const diferenciasEnDias = this.getDiasRestantes(fechaVencimiento);

      if (diferenciasEnDias <= 0) return '#EF5350';

      if (diferenciasEnDias <= 7 && diferenciasEnDias > 0) return 'warning';

      return 'success';
    },
    getIconFechaVencimiento(fechaVencimiento) {
      const diferenciasEnDias = this.getDiasRestantes(fechaVencimiento);

      if (diferenciasEnDias <= 0) return 'mdi-clock-time-eleven-outline';

      if (diferenciasEnDias <= 7 && diferenciasEnDias > 0) return 'mdi-clock-time-seven-outline';

      return 'mdi-clock-time-two-outline';
    },
    getColorStatus(estatus) {
      switch (estatus) {
        case 'PENDIENTE':
          return 'red darken-1';
        case 'POR RESPONDER':
          return 'orange';
        case 'RESPUESTA ENVIADA PARCIAL':
          return 'info';
        case 'RESPUESTA ENVIADA COMPLETA':
          return 'success';
        case 'SOLVENTADA':
          return 'green darken-1';
        default:
          return 'warning';
      }
    },
    agregarSeguimientoDetalleObservacion(detalle) {
      this.mostrarRegistrarSeguimiento = !this.mostrarRegistrarSeguimiento;
      this.esteDetalle = detalle;
    },
    mostrarDetalleSeguimiento(idDetalle) {
      this.esteDetalle = idDetalle;
      this.mostrarSeguimientos = !this.mostrarSeguimientos;
    },
    cancelarRegistrarRespuesta() {
      this.mostrarRegistrarSeguimiento = !this.mostrarRegistrarSeguimiento;
    },
    cerrarMostrarSeguimiento() {
      this.esteDetalle = null;
      this.mostrarSeguimientos = false;
    },
    handleMostrarEspecificaciones(detalle) {
      this.mostrarArchivosEspecificaciones = !this.mostrarArchivosEspecificaciones;
      this.esteDetalle = detalle || {};
    },
    handleCerrarArchivosEspecificaciones() {
      this.mostrarArchivosEspecificaciones = false;
      this.esteDetalle = null;
    },
  },
  computed: {
    getListadoContratoObservaciones() {
      if (!this.auditoriasInformesObservacionesDetalles) return [];

      return this.auditoriasInformesObservacionesDetalles?.data;
    },
  },
};
</script>

<style lang="scss">

</style>
